<device-detail>
  <div>
    <!-- Loading state -->
    <loading-spinner if={ state.loading } message="Cargando detalles del dispositivo..." />

    <!-- Error state -->
    <error-alert
      if={ state.error }
      message={ state.errorMessage }
      onretry={ retryLoading } />

    <!-- Device detail body -->
    <div if={ !state.loading && !state.error && state.device } class="device-detail-v2">

      <!-- ─── Device Header ─── -->
      <div class="d-flex flex-wrap justify-content-between align-items-end gap-3 mb-4">
        <div>
          <div class="d-flex align-items-center gap-2 mb-1">
            <h1 class="dd-header-name mb-0">{ state.device.name }</h1>
            <span class="dd-status { state.isOnline ? 'online' : 'offline' }">
              <span class="dd-status-dot"></span>
              { state.isOnline ? 'Online' : 'Offline' }
            </span>
          </div>
          <div class="dd-path">{ state.device.app } / { state.device.city } / { state.device.name }</div>
        </div>

        <div class="d-flex align-items-center gap-2">
          <button
            type="button"
            class="btn btn-outline-secondary btn-sm"
            onclick={ handleRefreshDevice }
            disabled={ !state.isOnline || state.commandStatus.loading }
            title="Actualizar datos e información del dispositivo">
            <i class="bi bi-arrow-clockwise me-1"></i> Actualizar
          </button>
          <button
            if={ isAdmin() }
            type="button"
            class="btn btn-outline-secondary btn-sm"
            onclick={ handleFullEdit }>
            <i class="bi bi-pencil-square me-1"></i> Editar dispositivo
          </button>
        </div>
      </div>

      <!-- ─── Vitals ─── -->
      <div class="row g-3 mb-4">
        <div class="col-6 col-lg-3">
          <div class="card dd-vital h-100">
            <div class="card-body d-flex align-items-center gap-3 py-3">
              <span class="dd-vital-icon"><i class="bi bi-clock-history"></i></span>
              <div class="min-w-0">
                <div class="dd-vital-label">Uptime</div>
                <div class="dd-vital-value">{ getUptime() }</div>
                <div class="dd-vital-sub text-truncate">{ state.device.data?.resetReason || 'Sin datos' }</div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-6 col-lg-3">
          <div class="card dd-vital h-100">
            <div class="card-body d-flex align-items-center gap-3 py-3">
              <span class="dd-vital-icon"><i class="bi bi-arrow-repeat"></i></span>
              <div class="min-w-0">
                <div class="dd-vital-label">Reinicios</div>
                <div class="dd-vital-value">{ state.device.data?.numResets ?? '—' }</div>
                <div class="dd-vital-sub">Total registrados</div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-6 col-lg-3">
          <div class="card dd-vital h-100">
            <div class="card-body d-flex align-items-center gap-3 py-3">
              <span class="dd-vital-icon"><i class="bi bi-lightning-charge"></i></span>
              <div class="min-w-0">
                <div class="dd-vital-label">Voltaje (VIN)</div>
                <div class="dd-vital-value">{ getVoltage() }</div>
                <div class="dd-vital-sub">{ getVoltage() === '—' ? 'Sin datos' : 'Nivel normal' }</div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-6 col-lg-3">
          <div class="card dd-vital h-100">
            <div class="card-body d-flex align-items-center gap-3 py-3">
              <span class="dd-vital-icon"><i class="bi bi-reception-4"></i></span>
              <div class="min-w-0">
                <div class="dd-vital-label">Señal WiFi</div>
                <div class="dd-vital-value">{ getRssi() }</div>
                <div class="dd-vital-sub">{ getRssiQuality() }</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ─── Tabs ─── -->
      <ul class="nav nav-underline mb-4" role="tablist">
        <li class="nav-item">
          <button class="nav-link { state.activeTab === 'control' ? 'active' : '' }" onclick={ () => setTab('control') }>
            <i class="bi bi-sliders me-1"></i>Control
          </button>
        </li>
        <li class="nav-item" if={ isAdmin() }>
          <button class="nav-link { state.activeTab === 'config' ? 'active' : '' }" onclick={ () => setTab('config') }>
            <i class="bi bi-gear-wide-connected me-1"></i>Configuración
          </button>
        </li>
        <li class="nav-item">
          <button class="nav-link { state.activeTab === 'history' ? 'active' : '' }" onclick={ () => setTab('history') }>
            <i class="bi bi-clock-history me-1"></i>Historial
          </button>
        </li>
        <li class="nav-item">
          <button class="nav-link { state.activeTab === 'system' ? 'active' : '' }" onclick={ () => setTab('system') }>
            <i class="bi bi-hdd-stack me-1"></i>Sistema
          </button>
        </li>
        <li class="nav-item" if={ isAdmin() }>
          <button class="nav-link { state.activeTab === 'innobing' ? 'active' : '' }" onclick={ () => setTab('innobing') }>
            <i class="bi bi-link-45deg me-1"></i>Innobing
          </button>
        </li>
      </ul>

      <!-- ═══ CONTROL ═══ -->
      <div class={ state.activeTab === 'control' ? '' : 'd-none' }>
        <div class="row g-3">
          <div class="col-12 col-xl-8">
            <device-status-control
              device={ state.device }
              isonline={ state.isOnline }
              commandstatusloading={ state.commandStatus.loading }
              onrefreshstate={ () => handleSendCommand('all_state') }
              onopendoor={ handleOpenDoor }
              onpulseseq={ () => handleSendCommand('pulse_seq') }
              oneditschedule={ handleEditSchedule }
              onshowschedulehelp={ handleShowScheduleHelp }
            ></device-status-control>
          </div>
          <div class="col-12 col-xl-4">
            <device-info-card
              device={ state.device }
              user={ state.user }
              isadmin={ isAdmin() }
              isonline={ state.isOnline }
              elapsedseconds={ state.elapsedSeconds }
              ondeviceupdated={ (dev) => update({ device: dev }) }
            ></device-info-card>
          </div>
        </div>
      </div>

      <!-- ═══ CONFIGURACIÓN ═══ -->
      <div if={ isAdmin() } class={ state.activeTab === 'config' ? '' : 'd-none' }>
        <device-config-editor device={ state.device } isonline={ state.isOnline } ></device-config-editor>
      </div>

      <!-- ═══ HISTORIAL ═══ -->
      <div class={ state.activeTab === 'history' ? '' : 'd-none' }>
        <device-history
          deviceId={ state.device ? state.device._id : null }
          deviceChannels={ getDeviceChannels() }>
        </device-history>
      </div>

      <!-- ═══ SISTEMA ═══ -->
      <div class={ state.activeTab === 'system' ? '' : 'd-none' }>
        <div class="row g-3 mb-3">
          <div class="col-12" if={ isAdmin() }>
            <device-firmware
              isAdmin={ isAdmin() }
              deviceId={ state.device ? state.device._id : null }
              isOnline={ state.isOnline }
              deviceApp={ state.device ? state.device.app : null }
              deviceCity={ state.device ? state.device.city : null }
              deviceName={ state.device ? state.device.name : null }
            >
            </device-firmware>
          </div>

          <div class="col-12">
            <device-sentilo-config
              device={ state.device }
              isadmin={ isAdmin() }
              ondeviceupdated={ (dev) => update({ device: dev }) }
            ></device-sentilo-config>
          </div>
        </div>

        <!-- Zona de peligro -->
        <div class="card border-danger">
          <div class="card-header bg-danger bg-opacity-10 border-danger d-flex align-items-center gap-2">
            <i class="bi bi-exclamation-triangle-fill text-danger"></i>
            <span class="fw-semibold text-danger text-uppercase small">Zona de peligro</span>
          </div>
          <div class="list-group list-group-flush">
            <div class="list-group-item d-flex flex-wrap justify-content-between align-items-center gap-3">
              <div>
                <strong class="d-block">Reiniciar dispositivo</strong>
                <small class="text-muted">Envía un comando de reinicio al dispositivo.</small>
              </div>
              <button
                class="btn btn-outline-danger btn-sm"
                onclick={ () => handleSendCommand('reboot') }
                disabled={ !state.isOnline || state.commandStatus.loading }
              >
                <i class="bi bi-power me-1"></i> Reiniciar
              </button>
            </div>
            <div if={ isAdmin() } class="list-group-item d-flex flex-wrap justify-content-between align-items-center gap-3">
              <div>
                <strong class="d-block">Eliminar dispositivo</strong>
                <small class="text-muted">Esta acción no se puede deshacer.</small>
              </div>
              <button
                class="btn btn-danger btn-sm"
                onclick={ handleDeleteConfirmation }
                disabled={ state.deleting }
              >
                <i class="bi bi-trash me-1"></i> Eliminar dispositivo
              </button>
            </div>
          </div>
        </div>
      </div>


      <!-- ═══ INNOBING ═══ -->
      <div if={ isAdmin() } class={ state.activeTab === 'innobing' ? '' : 'd-none' }>
        <div class="row g-3">
          <div class="col-12 col-xl-6">
            <device-innobing-config
              if={ state.activeTab === 'innobing' }
              device={ state.device }
              isadmin={ isAdmin() }
            ></device-innobing-config>
          </div>
        </div>
      </div>


      <!-- Command response modal -->
      <div class="modal fade" id="commandResponseModal" tabindex="-1" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
        <div class="modal-dialog">
          <div class="modal-content border-{ state.commandStatus.color }">
            <div class="modal-header bg-{ state.commandStatus.color } bg-opacity-10">
              <h5 class="modal-title text-{ state.commandStatus.color }">
                { state.commandStatus.title }
              </h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" disabled={ state.commandStatus.loading }></button>
            </div>
            <div class="modal-body p-4">
              <!-- Loading screen -->
              <div if={ state.commandStatus.loading } class="text-center py-4">
                <div class="spinner-border text-primary mb-3" style="width: 3rem; height: 3rem;" aria-live="polite" aria-label="Cargando">
                  <span class="visually-hidden">Cargando...</span>
                </div>
                <h5 class="mb-2">Enviando comando...</h5>
                <p class="text-muted">
                  Espere mientras se envía el comando al dispositivo.
                </p>
              </div>

              <!-- Result (success or error) -->
              <div if={ !state.commandStatus.loading } class="text-center py-3">
                <!-- Status icon -->
                <div class="mb-3">
                  <i if={ state.commandStatus.status === 'success' } class="bi bi-check-circle-fill text-success" style="font-size: 4rem;"></i>
                  <i if={ state.commandStatus.status === 'error' } class="bi bi-x-circle-fill text-danger" style="font-size: 4rem;"></i>
                  <i if={ state.commandStatus.status === 'timeout' } class="bi bi-exclamation-triangle-fill text-warning" style="font-size: 4rem;"></i>
                </div>

                <!-- Title based on result -->
                <h4 class="mb-3 text-{ state.commandStatus.color }">{ state.commandStatus.resultTitle }</h4>

                <!-- Message -->
                <p class="mb-3">{ state.commandStatus.message }</p>

                <!-- Display payload if available -->
                <div if={ state.commandStatus.payload } class="text-start bg-light p-3 rounded mt-3">
                  <h6>Datos recibidos:</h6>
                  <pre class="mb-0" style="white-space: pre-wrap; word-wrap: break-word;">
                    <code>{ formatPayload(state.commandStatus.payload) }</code>
                  </pre>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary"
                data-bs-dismiss="modal"
                disabled={ state.commandStatus.loading }
              >
                Cerrar
              </button>
              <button
                if={ state.commandStatus.status === 'error' || state.commandStatus.status === 'timeout' }
                type="button"
                class="btn btn-primary"
                onclick={ handleRetryCommand }
                disabled={ state.commandStatus.loading }
              >
                Reintentar
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Delete confirmation modal -->
      <div class="modal fade" id="deleteConfirmationModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header bg-danger text-white">
              <h5 class="modal-title">Confirmar eliminación</h5>
              <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <p>¿Está seguro de que desea eliminar el dispositivo <strong>{ state.device.name }</strong>?</p>
              <p class="mb-0">Esta acción no se puede deshacer. Todos los datos asociados con este dispositivo se eliminarán permanentemente.</p>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
              <button
                type="button"
                class="btn btn-danger"
                onclick={ handleDeleteDevice }
                disabled={ state.deleting }
              >
                { state.deleting ? 'Eliminando...' : 'Sí, eliminar dispositivo' }
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

    <script>
    import { Modal } from 'bootstrap';
    import LoadingSpinner from './loading-spinner.riot';
    import ErrorAlert from './error-alert.riot';
    import DeviceHistory from './device-history.riot';
    import DeviceSentiloConfig from './device-sentilo-config.riot';
    import DeviceInfoCard from './device-info-card.riot';
    import DeviceStatusControl from './device-status-control.riot';
    import DeviceFirmware from './device-firmware.riot';
    import DeviceConfigEditor from './device-config-editor.riot';
    import DeviceInnobing from './device-innobing-config.riot';
    import { AuthService, DeviceService } from '../services';
    import { ToastService } from '../services/toast-service';
    import { deviceStore } from '../services/device.store';
    import { formatDate } from '../utils/device-utils';

    const VALID_TABS = ['control', 'config', 'history', 'system', 'innobing'];

    export default {
      instanceId: Date.now() + Math.random().toString(16).substring(2),
      modalInstances: {},

      components: {
        'loading-spinner': LoadingSpinner,
        'error-alert': ErrorAlert,
        'device-firmware': DeviceFirmware,
        'device-config-editor': DeviceConfigEditor,
        'device-innobing-config': DeviceInnobing,
        'device-history': DeviceHistory,
        'device-sentilo-config': DeviceSentiloConfig,
        'device-info-card': DeviceInfoCard,
        'device-status-control': DeviceStatusControl
      },

      onBeforeMount() {
        this.state = {
          deleting: false,
          user: null,
          activeTab: this.getTabFromHash() || 'control',
          ...deviceStore.getState()
        };
      },

      getTabFromHash() {
        const hash = (window.location.hash || '').replace(/^#/, '');
        return VALID_TABS.includes(hash) ? hash : null;
      },

      setTab(tab) {
        if (!VALID_TABS.includes(tab)) return;
        this.update({ activeTab: tab });
        // Reflejar el tab en la URL SIN crear entrada en el historial
        // (replaceState en vez de location.hash, que sí empujaría al history).
        const url = window.location.pathname + window.location.search + '#' + tab;
        window.history.replaceState(null, '', url);
      },

      async onMounted() {
        // Subscribe to global store, merging its properties into this component's state
        this.unsubscribe = deviceStore.subscribe((storeState) => {
          this.update(storeState);
        });

        // Permitir acceder a los tabs editando el hash de la URL directamente.
        // No afecta al history: nunca hacemos pushState para los tabs.
        this.onHashChange = () => {
          const tab = this.getTabFromHash();
          if (tab && tab !== this.state.activeTab) {
            this.update({ activeTab: tab });
          }
        };
        window.addEventListener('hashchange', this.onHashChange);

        this.update({
          user: AuthService.getUserData()
        });

        if (!this.state.user) {
          await this.getCurrentUser();
        }

        const deviceId = this.props.deviceId || this.getDeviceIdFromUrl();
        if (deviceId) {
          await deviceStore.fetchDevice(deviceId);
        } else {
           this.update({ error: true, errorMessage: 'No se ha especificado un ID de dispositivo' });
        }
      },

      onUnmounted() {
        if (this.unsubscribe) this.unsubscribe();
        if (this.onHashChange) window.removeEventListener('hashchange', this.onHashChange);
        deviceStore.reset();
      },

      getCommandModal() {
        const el = document.getElementById('commandResponseModal');
        if (!el) return null;
        return Modal.getOrCreateInstance(el, { backdrop: 'static', keyboard: false });
      },

      getDeleteModal() {
        const el = document.getElementById('deleteConfirmationModal');
        if (!el) return null;
        return Modal.getOrCreateInstance(el);
      },

      async getCurrentUser() {
        try {
          const userData = await AuthService.getCurrentUser();
          this.update({ user: userData });
        } catch (error) {
          console.error('Error fetching user data:', error);
          if (error.message.includes('sesión') || error.message.includes('autenticación')) {
            alert('Tu sesión ha expirado. Por favor, inicia sesión nuevamente.');
            if (this.props.onlogout) this.props.onlogout();
            else if (window.handleLogout) window.handleLogout();
            else window.location.reload();
          }
        }
      },

      getDeviceIdFromUrl() {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get('id');
      },

      isAdmin() {
        return this.state.user &&
               (this.state.user.roles && this.state.user.roles.includes('admin'));
      },

      handleBackToList(e) {
        if (e) e.preventDefault();
        if (this.props.onback) this.props.onback();
        else window.location.href = '/devices';
      },

      handleFullEdit(e) {
        if (e) e.preventDefault();
        if (this.state.device && this.state.device._id) {
          window.history.pushState({}, '', `/create-device?id=${this.state.device._id}`);
          window.dispatchEvent(new PopStateEvent('popstate'));
        }
      },

      retryLoading() {
        const deviceId = this.props.deviceId || this.getDeviceIdFromUrl();
        if (deviceId) {
           deviceStore.fetchDevice(deviceId);
        }
      },

      handleEditSchedule(channel) {
        if (this.props.oneditschedule) {
          this.props.oneditschedule(this.state.device._id, this.state.device.name, channel);
        }
      },

      handleShowScheduleHelp(e) {
        if (e) e.preventDefault();
        if (window.helpScheduleModal) window.helpScheduleModal.show();
      },

      async handleOpenDoor(channel) {
        await this.handleSendCommand(channel, 'PULSE');
      },

      async handleSendCommand(channel, state = undefined) {
        if (!this.state.device) return;

        const modal = this.getCommandModal();
        if (modal) modal.show();

        await deviceStore.sendCommand(this.state.device._id, channel, state);
      },

      // Refresca datos de funcionamiento (all_data) e información técnica (all_info),
      // que es lo que alimenta los vitals y la sidebar de Identidad.
      async handleRefreshDevice() {
        if (!this.state.device) return;

        const modal = this.getCommandModal();
        if (modal) modal.show();

        await deviceStore.sendCommand(this.state.device._id, 'all_data');
        await deviceStore.sendCommand(this.state.device._id, 'all_info');
      },

      handleRetryCommand() {
        const cmd = this.state.commandStatus.lastCommand;
        if (cmd && cmd.deviceId && cmd.channel) {
          this.handleSendCommand(cmd.channel, cmd.state);
        }
      },

      handleDeleteConfirmation() {
        const modal = this.getDeleteModal();
        if (modal) modal.show();
      },

      async handleDeleteDevice() {
        this.update({ deleting: true });
        try {
          await DeviceService.deleteDevice(this.state.device._id);
          const m = this.getDeleteModal();
          if (m) m.hide();
          ToastService.show('Dispositivo eliminado correctamente', 'success');
          setTimeout(() => this.handleBackToList(), 1500);
        } catch (error) {
          console.error('Error deleting device:', error);
          this.update({ deleting: false });
          const m2 = this.getDeleteModal();
          if (m2) m2.hide();
          ToastService.show('Error al eliminar el dispositivo: ' + (error.message || 'Error desconocido'), 'danger');
        }
      },

      getDeviceChannels() {
        return this.state.device?.channels || [];
      },

      formatRSSI(rssi) {
        if (!rssi) return '';
        if (rssi >= -50) return '(Excelente)';
        if (rssi >= -60) return '(Muy buena)';
        if (rssi >= -70) return '(Buena)';
        if (rssi >= -80) return '(Regular)';
        return '(Débil)';
      },

      getUptime() {
        const uptime = this.state.device?.data?.uptime;
        return uptime !== undefined ? this.formatUptime(uptime) : '—';
      },

      getVoltage() {
        const vin = this.state.device?.data?.vin_value ?? this.state.device?.data?.powerInValue;
        return vin !== undefined && vin !== null ? `${vin.toFixed(2)} V` : '—';
      },

      getRssi() {
        const rssi = this.state.device?.details?.rssi;
        return rssi !== undefined ? `${rssi} dBm` : '—';
      },

      getRssiQuality() {
        const rssi = this.state.device?.details?.rssi;
        if (rssi === undefined) return 'Sin datos';
        return this.formatRSSI(rssi).replace(/[()]/g, '');
      },

      formatDate(timestamp) {
        return formatDate(timestamp);
      },

      formatUptime(totalSeconds) {
        if (typeof totalSeconds !== 'number') return '';
        const days = Math.floor(totalSeconds / 86400);
        const hours = Math.floor((totalSeconds % 86400) / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = Math.floor(totalSeconds % 60);

        const parts = [];
        if (days) parts.push(`${days}d`);
        if (hours) parts.push(`${hours}h`);
        if (minutes) parts.push(`${minutes}m`);
        if (!days && !hours && !minutes) parts.push(`${seconds}s`);
        return parts.join(' ');
      },

      async copyToClipboard(text, toastMessage = 'Copiado') {
        try {
          if (!text) return;
          const nav = typeof navigator !== 'undefined' ? navigator : null;
          if (nav && nav.clipboard && typeof nav.clipboard.writeText === 'function') {
            await nav.clipboard.writeText(String(text));
            ToastService.show(toastMessage, 'success');
          }
        } catch (err) {
          console.error('Clipboard error:', err);
          ToastService.show('No se pudo copiar', 'danger');
        }
      },

      formatPayload(payload) {
        if (typeof payload === 'string') {
          try { return JSON.stringify(JSON.parse(payload), null, 2); } catch { return payload; }
        }
        return JSON.stringify(payload, null, 2);
      }
    }
  </script>
</device-detail>
